export default __webpack_public_path__ + "static/media/Dybala.546fc067.jpg";